function redo(query, actions) {
  // If query and actions are not available, return
  if (!query || !actions) {
    return;
  }

  if (query.history.canRedo()) {
    actions.history.canRedo();
  }
}

export default redo;
